import React from 'react';
import Style from './LoadingMessage.style';

export const LoadingMessage = () => {
  return (
    <Style>
      <div className="loaderRollerWrapper">
        <div className="lds-roller">
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
          <div/>
        </div>
      </div>

      <div className="loadingMessage">
        Wird geladen ...
      </div>
    </Style>
  );
};
